import { useMemo } from "react";
import { useGetBulkDisbursementRecipientStatusFilters } from "../../../../hooks/queries/useBulkUploadsQueries";
import { BATCH_TRANSACTION_STATUS_VALUE_BY_LABEL } from "../constants/batchTransactionsConstants";

export const useBatchTransactionStatusOptions = () => {
  const {
    data: labels = [],
    isLoading,
    isError,
  } = useGetBulkDisbursementRecipientStatusFilters();

  const options = useMemo(() => {
    return labels
      .map((label) => {
        const value = BATCH_TRANSACTION_STATUS_VALUE_BY_LABEL[label];
        if (!value) return null;
        return { value, label };
      })
      .filter(Boolean);
  }, [labels]);

  const optionsWithAll = useMemo(
    () => [{ value: "all", label: "All Statuses" }, ...options],
    [options],
  );

  return {
    options,
    optionsWithAll,
    isLoading,
    isError,
    hasOptions: options.length > 0,
  };
};

export default useBatchTransactionStatusOptions;
